<div *ngIf="print.load" class="body-wrapper" style="direction: rtl; padding-top: 0">
  <header class="header">
    <div class="justify-between items-center" style="margin-bottom: 5px; text-align: center; margin-bottom: 3%"></div>
    <div class="header-details"></div>
  </header>
  <main class="main">
    <section class="section marginBottom" *ngIf="print.billingReports && print.billingReports.length">
      <div style="display: flex;flex-direction: row-reverse;align-content: center;justify-content: space-around;">
        <h3 >from: {{this.fromDate | date : "dd.MM.yyyy"}}</h3>
        <h3 >to: {{this.toDate | date : "dd.MM.yyyy"}} </h3>
        <h3 > {{ print.doctorInfo.Title}} {{print.doctorInfo.Name}}  :for</h3>
      </div>
      <ng-container>
        <div class="container">
          <table style="width: 100%">
            <thead>
              <tr>
                <th>#</th>
                <th>Type</th>
                <th class="clickable">Creation Date</th>
                <th>Number</th>
                <th>For</th>
                <th>Subject</th>
                <th>Payment Method</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              <ng-container>
                <tr *ngFor="let result of print.billingReports | sortByDate:'DateCreated' ; let i = index" >
                  <td>{{ i + 1 }}</td>
                  <td>{{ result.TypeName }}</td>
                  <td>{{ result.DateCreated | date : "dd.MM.yyyy" }}</td>
                  <td>{{ result.DocumentNumber }}</td>
                  <td>{{ result.Recipient }}</td>
                  <td>{{ result.Subject }}</td>
                  <td>{{ result.PaymentMethodName }}</td>
                  <td>{{ result.Price }} ₪</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-container>
    </section>
  </main>
</div>
